import { createThunk, ListModel, model } from 'mst-collection';
import { castToSnapshot, getParent, types } from 'mobx-state-tree';

import { MessageModel } from './MessageModel';
import { Api, schemas } from '@api';
import { handleFlow, shouldRejectPagination } from '../utils';
import type { Conversation } from './ConversationModel';

export class MessageList extends ListModel(
  types.reference(MessageModel),
  {
    idAttribute: 'id',
    schema: schemas.MessageListSchema,
    pageSize: 20,
  },
) {
  private get _parentConversation(): Conversation {
    return getParent<Conversation>(this);
  }

  fetch = createThunk(() => {
    return async function fetch(this: MessageList) {
      const res = await Api.Messaging.getMessages({
        id: this._parentConversation.user.id,
      });

      if (this._parentConversation?.hasNewMessages) {
        this._parentConversation.clearNewCount();
      }

      this.set(res.data.messages);
    };
  });

  fetchMore = createThunk(() => {
    return async function fetchMore(this: MessageList, flow) {
      if (shouldRejectPagination(this)) {
        return;
      }

      await handleFlow(flow, async () => {
        const res = await Api.Messaging.getMessages({
          id: this._parentConversation.user.id,
          count: this.pageSize,
          start: this.offset,
        });
        this.append(castToSnapshot(res.data.messages));
      });
    };
  }, false);
}

export const MessageListModel = model(MessageList);
